import * as React from "react"
import { IconProps } from "./interfaces/IconProps.interface"
const TrashFilled = ({ color, ...props }: IconProps) => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M19.8335 6.99967H25.6668V9.33301H23.3335V24.4997C23.3335 24.8091 23.2106 25.1058 22.9918 25.3246C22.773 25.5434 22.4762 25.6663 22.1668 25.6663H5.8335C5.52408 25.6663 5.22733 25.5434 5.00854 25.3246C4.78975 25.1058 4.66683 24.8091 4.66683 24.4997V9.33301H2.3335V6.99967H8.16683V3.49967C8.16683 3.19026 8.28975 2.89351 8.50854 2.67472C8.72733 2.45592 9.02408 2.33301 9.3335 2.33301H18.6668C18.9762 2.33301 19.273 2.45592 19.4918 2.67472C19.7106 2.89351 19.8335 3.19026 19.8335 3.49967V6.99967ZM10.5002 12.833V19.833H12.8335V12.833H10.5002ZM15.1668 12.833V19.833H17.5002V12.833H15.1668ZM10.5002 4.66634V6.99967H17.5002V4.66634H10.5002Z"
            fill={color || "#000"}
        />
    </svg>
)
export default TrashFilled
